<template>
	<div class="form-elements">
		<div class="row">
			<div class="col-md-12">
				<vuestic-widget headerText="Carga Horária de Aulas Teóricas">
					<div class="row">
						<div class="col-md-6">
							<model-select :options="nomesAlunos" v-model="getAluno" placeholder="Selecione um aluno"></model-select>
						</div>
						<div class="col-md-6">
							<button @click="buscarCargaHoraria()" class="btn btn-block btn-lg btn-secondary">Gerar</button>
						</div>

            <div class="col-md-12" v-show="dadosAluno && !load">
              <br><br><br><br><br>
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th colspan="5" class="text-left">Nome: {{ dadosAluno.nome }}<br>RENACH: {{ dadosAluno.renach }}</th>
                  </tr>
                  <tr>
                    <th>#</th>
                    <th>Disciplina</th>
                    <th>Horas Exigidas</th>
                    <th>Horas Cumpridas</th>
                    <th>Horas Agendadas</th>
                  </tr>
                </thead>
                <tbody v-for="(aula, index) in dadosAula">
                  <tr>
                    <td>{{ index + 1 }}</td>
                    <td>{{ aula.disciplina }}</td>
                    <td>{{ aula.horas_exigidas }}</td>
                    <td>{{ aula.horas_cumpridas }}</td>
                    <td>{{ aula.horas_agendadas }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
					</div>
				</vuestic-widget>

				<div v-show="load">
					<div class="d-flex justify-content-center">
						<div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
							<component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { ModelSelect } from 'vue-search-select'
	import * as spinners from "epic-spinners"
	import urlApi from '../../router/urlApi'

	export default {
		name: "cargaHorariaAulasTeoricas",
		components: {
			...spinners,
			ModelSelect
		},
		data() {
			return {
				load: false,
				nomesAlunos: [],
				item: {
					alunoId: '',
					alunoName: ''
				},
				getAluno: '',
        dadosAula: [],
        dadosAluno: []
			}
		},
		mounted() {
		},
		created: function() {
			const url = `${urlApi}/alunos`;
			this.$http.get(url).then((res) => {
				const dadosAlunos = res.data.dados;

				dadosAlunos.forEach((aluno) => {
					this.nomesAlunos.push({'value': aluno.id_aluno, 'text': aluno.nome});
				})
			});
		},
		methods: {
			buscarCargaHoraria() {
				this.load = true;
				const idAluno = this.getAluno;
				const url = `${urlApi}/alunos/carga-horaria-aulas-teoricas/${idAluno}`;
				this.$http.get(url).then((res) => {
          this.dadosAluno = res.data.dados.aluno;
          this.dadosAula = res.data.dados.detalhes_aula;
          //console.log(res.data.dados);
					this.load = false;
				});
			},
			reset () {
				this.item = {}
			},
			selectFromParentComponent1 () {
				this.item = this.options[0]
			},
			reset2 () {
				this.item2 = ''
			},
			selectFromParentComponent2 () {
				this.item2 = this.options2[0].value
			}
		}
	};
</script>
